import React from 'react';
import { Drawer, Button, Form, DatePicker } from 'antd';

import axios from 'axios';

const DrawerFiltros = ({ visible, onClose, url, params }) => {
    console.log('url',url);


    const handleSubmit = async (values) => {
        const { createdAt } = values;

        try {
            let base_url = new URL(axios.defaults.baseURL + url);
            console.log('url',url);

            base_url.searchParams.set('csv', true)
            base_url.searchParams.set('Authorization', sessionStorage.getItem('token'))

            if (createdAt && createdAt.length === 2) {
                base_url.searchParams.set('createdAt', JSON.stringify(createdAt));
            }

            if (params) {
                Object.entries(params).forEach(([key, value]) => {
                    base_url.searchParams.set(key, value);
                });
            }

            window.open(base_url, '_blank');
        } catch (error) {
            console.error('Error al aplicar filtros:', error);
        }
    }


    return (
        <Drawer
            title="Filtros"
            placement="right"
            onClose={onClose}
            open={visible}
            width={350}
        >
            <Form
                layout="vertical"
                name="filtros"
                onFinish={handleSubmit}
            >
                <Form.Item label="Rango de Fechas" name="createdAt">
                    <DatePicker.RangePicker style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" block htmlType='submit'>
                        Descargar CSV
                    </Button>
                </Form.Item>
            </Form>
    
        </Drawer>
    );
};

export default DrawerFiltros;